import script from "./ForgetMeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForgetMeView.vue?vue&type=script&setup=true&lang=ts"

import "./ForgetMeView.vue?vue&type=style&index=0&id=6febb0a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6febb0a4"]])

export default __exports__